import React, { useState } from 'react';
import { Zap, CreditCard, ShieldCheck, Info } from 'lucide-react';

interface GeminiSubscriptionManagerProps {
  userGeminiKey: string;
  setUserGeminiKey: (key: string) => void;
  isPaidSubscriber: boolean;
  setIsPaidSubscriber: (isPaid: boolean) => void;
}

const GeminiSubscriptionManager: React.FC<GeminiSubscriptionManagerProps> = ({
  userGeminiKey,
  setUserGeminiKey,
  isPaidSubscriber,
  setIsPaidSubscriber,
}) => {
  const [keyInput, setKeyInput] = useState(userGeminiKey);

  const saveKey = () => {
    localStorage.setItem('userGeminiKey', keyInput);
    setUserGeminiKey(keyInput);
    alert('Key saved!');
  };

  return (
    <div className="terminal-screen rounded-2xl p-6 space-y-6">
      <h2 className="font-orbitron text-xl font-bold text-amber-500 flex items-center gap-2 relative z-10">
        <Zap className="text-amber-500" />
        Tucson Cyber-West AI Engine
      </h2>
      
      <div className="text-sm text-amber-400 space-y-2 font-mono relative z-10">
        <p>
          <Info size={14} className="inline mr-1" />
          <strong>How AI works for us:</strong> We use advanced AI models to process police radio, dispatch alerts, and crime data. 
          "Tokens" are the units of text the AI processes. Each request consumes tokens, which have a monetary cost.
        </p>
        <p>
          By using your own Gemini API key, you get lightning-fast responses and ensure you never miss critical data.
        </p>
      </div>

      {!isPaidSubscriber && (
        <div className="bg-amber-900/10 p-4 rounded-xl border border-amber-800/30 relative z-10">
          <h3 className="text-amber-500 font-bold mb-2 font-mono uppercase tracking-widest">Support Tactical Intel</h3>
          <p className="text-amber-400 text-xs mb-4 font-mono">
            Donate $15.00 to $thenobleglitch via Cash App for lifetime access, custom timer intervals, and the ability to use your own Gemini API key.
          </p>
          <button 
            onClick={() => {
              window.open('https://cash.app/$thenobleglitch', '_blank');
              setIsPaidSubscriber(true);
              localStorage.setItem('isPaidSubscriber', 'true');
            }}
            className="w-full bg-amber-600 hover:bg-amber-500 text-black font-bold py-2 rounded-xl transition-all flex items-center justify-center gap-2 font-mono"
          >
            <CreditCard size={16} />
            CONFIRM DONATION ($15)
          </button>
        </div>
      )}

      {isPaidSubscriber && (
        <div className="space-y-4 relative z-10">
          <div className="space-y-2">
            <label className="text-xs text-amber-400 uppercase tracking-widest font-mono">Your Gemini API Key</label>
            <input 
              type="password"
              value={keyInput}
              onChange={(e) => setKeyInput(e.target.value)}
              className="w-full terminal-input rounded-lg p-2 text-sm"
              placeholder="AIza..."
            />
            <button 
              onClick={saveKey}
              className="w-full bg-amber-900/50 hover:bg-amber-800 text-amber-500 text-xs py-2 rounded-lg transition-all font-mono font-bold tracking-widest"
            >
              SAVE KEY
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeminiSubscriptionManager;
